export default __webpack_public_path__ + "static/media/projects-intro.084508fb.png";